const getUserId = () => {
    return JSON.parse(localStorage.getItem('authUser'))?.id;
}

const can = (permission) => {
    return  JSON.parse(localStorage.getItem('authUser'))?.effective_permissions?.includes(permission)
}

const isSuperUser = () => {
    const authUser = JSON.parse(localStorage.getItem('authUser'));
    return authUser?.is_superuser || authUser?.groups?.includes('Admins');
}

const getGroups = () => {
    return JSON.parse(localStorage.getItem('authUser'))?.groups || [];
}

// Group 3 only → ops user (restricted: can only view their own data)
const isOpsUser = () => {
    const groups = getGroups();
    return groups.includes(3) && !groups.includes(1) && !groups.includes(2);
}

// Group 1 or 2 → ops lead (can view all assignees)
const isOpsLead = () => {
    const groups = getGroups();
    return groups.includes(1) || groups.includes(2);
}

export { getUserId, can, isSuperUser, getGroups, isOpsUser, isOpsLead };